export * from './bingo-board.component';
export * from './bingo-board.module';
